<ng-container>
	<base-display [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()" [scaleElements]="getScaleElements()" [showScale]="hasScale()" [scaleType]="scaleType()"></base-display>
</ng-container>